import { User } from './user';

export class Permission {
  name!: string;
  description?: string;
  action?: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  static getSortColumns() {
    return [
      'name',
      'description',
      'action',
      'email',
      'phone_number',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.action = data.action;
    this.description = data.description;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
